import { defineComponent as _defineComponent } from 'vue'
import { Meetings, InviteLinks } from '@busy-human/opt-library'
import { ref, computed } from 'vue'
import TextField from "@/components/text-area.vue"
import VCheckbox from '@/components/checkmarkbox.vue'
import { useUserspace } from '@/store/userspace';


type Props = {
    request: Meetings.Model
}
type Emits = {
    (e: 'update:request', request: Meetings.Model): void
    (e: 'previous'): void
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'contact-details',
  props: {
    request: null
  },
  emits: ["update:request", "previous", "progress"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:request', request: Meetings.Model): void
    (e: 'previous'): void
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    request: Meetings.Model
}





const currentUser = computed(()=> useUserspace().user)
const message = ref('')
const shareNumber = ref(false)
const shareEmail = ref(false)

const previous = () => {
    emit('previous');
}

const proceed = () => {
    let tmpMeeting =  props.request
    let messageSections = []
    if(shareNumber.value){
        messageSections.push(`Phone Number: ${currentUser.value.phone}`)
    }
    if(shareEmail.value){
        messageSections.push(`Email: ${currentUser.value.email}`)
    }
    if(message.value){
        messageSections.push(message.value)
    }

    if(messageSections.length > 0){
        let contactMessage = messageSections.join(` \n`)
        tmpMeeting.receiversContactInfo = contactMessage
        emit('update:request',tmpMeeting)
    }

    emit('progress');
}


const __returned__ = { props, emit, currentUser, message, shareNumber, shareEmail, previous, proceed, Meetings, InviteLinks, ref, computed, TextField, VCheckbox, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})